import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import Guid from "_shared/guids/guid";
import TopicSchema, { TopicJSON, TopicParams } from "messaging/forums/topics/topic-schema";
import ForumEntityClass from "notifications/values/forum-entity-class/forum-entity-class";

export default class Topic {
  public static readonly EXAMPLE: Topic = new Topic({
    entityClass: new ForumEntityClass("TestEntityClass"),
    entityId: Guid.generate(),
    context: "TestContext",
  });

  public static create(params: TopicParams): Topic {
    const parsed = TopicSchema.validate(params);
    return new Topic(parsed);
  }

  public static fromJSON(json: unknown): Topic | null | undefined {
    if (isNullOrUndefined(json)) return json;
    const parsed = TopicSchema.deserialize(json);
    return new Topic(parsed);
  }

  public readonly entityClass?: ForumEntityClass;
  public readonly entityId?: Guid;
  public readonly context?: string;

  public toJSON(): TopicJSON {
    return TopicSchema.serialize(this);
  }

  public isEqualTo(other?: Topic): boolean {
    if (!other) return false;
    return Boolean(
      this.entityClass?.isEqualTo(other.entityClass) &&
      this.entityId?.value === other.entityId?.value &&
      this.context === other.context,
    );
  }

  public toString(): string {
    return `${this.entityClass}/${this.entityId?.value}/${this.context}`;
  }

  public constructor(params: TopicParams) {
    this.entityClass = params.entityClass;
    this.entityId = params.entityId;
    this.context = params.context;
  }
}
